<template>
  <div id="permissionsAccess" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content first-modal-content">
        <div class="modal-header modal-bgcolor">
          <button type="button" class="close" @click="cancelPermissions()">&times;</button>
          <div class="mem-name">
            {{ memberName }}
          </div>
          <div class="modal-title">{{ memberPermissions.name }}</div>
          <hr />
        </div>
        <div class="modal-body">
          <template v-for="(permit, index) in memberPermissions.modules">
            <div :key="index" class="module-text col-xs-12 col-sm-12">
              <div class="label_container">
                <span
                  class="checkbox mb-0 inline-checkbox"
                >
                  <label>
                  <input
                    type="checkbox"
                    v-model="permit.access"
                    :disabled="
                      !disablePermissionCheck(memberPermissions.name, 'module', permit.key)
                    "
                  />
                  <span class="cr"></span>
                  </label>
                </span>
                <div
                  class="ml-18 cursor-pointer flex_grow_1"
                  data-toggle="collapse"
                  :data-target="'#' + index + '_collapse'"
                >
                  <span>{{ permit.name }}</span>
                  <span class="collapse_arrow fa fa-angle-down"></span>
                </div>
              </div>
              <div :id="index + '_collapse'" class="collapse ml-30 xs-ml-15">
                <div
                  class="desc_text mr-30 xs-mr-15"
                  v-for="(value, index) in permit.operations"
                  :key="index"
                >
                  <span
                    class="checkbox inline-checkbox"
                  >
                  <label>
                    <input
                      type="checkbox"
                      v-model="value.access"
                      :disabled="
                        !disablePermissionCheck(
                          memberPermissions.name,
                          'operations',
                          permit.key,
                          value.key
                        )
                      "
                    /><span class="cr"></span>
                  </label>
                  </span>
                  <span>{{ value.name }}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="modal-footer modal-bgcolor">
          <div class="col-sm-12 col-xs-12 col-md-12 footer remove_button_padding">
            <div class="col-md-3 col-md-offset-6 col-sm-offset-4 col-sm-4 col-xs-6 xs-pd-lt-0">
              <button
                type="button"
                class="btn btn-block emergo-white-button"
                @click="cancelPermissions()"
              >
                Cancel
              </button>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-6 xs-pd-lt-0 xs-pd-rt-0">
              <button
                type="button"
                class="btn btn-block emergo-green-button"
                @click="savePermission()"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import cloneDeep from 'lodash/cloneDeep';

export default {
  props: [
    'rolesServicesList',
    'serviceId',
    'memberName',
    'userServiceList',
    'usersPermission',
    'updateUserPermission'
  ],
  data() {
    return {
      memberPermissions: {}
    };
  },
  mounted() {
    $('#permissionsAccess').on('shown.bs.modal', () => {
      this.memberPermissions = cloneDeep(
        this.userServiceList.find((service) => service.id === this.serviceId)
      );
    });
  },
  methods: {
    disablePermissionCheck(serviceName, key, moduleKey, operation) {
      const service = this.rolesServicesList.find(
        (roleService) => roleService.name === serviceName
      ); // selected service
      if (key === 'module') {
        // module level
        return service.modules.find((module) => module.key === moduleKey).access; // module accessable in selected service
      }
      // operations level validation
      const module = service.modules.find((serviceModule) => serviceModule.key === moduleKey);
      return module.operations.find((moduleOperation) => moduleOperation.key === operation).access;
    },
    cancelPermissions() {
      this.memberPermissions = {};
      $('#permissionsAccess').modal('hide');
    },
    savePermission() {
      this.$emit('updateUserPermission', this.memberPermissions, this.serviceId);
      this.memberPermissions = {};
      $('#permissionsAccess').modal('hide');
    }
  }
};
</script>
<style lang="scss" scoped>
.collapse {
  div {
    &.desc_text {
      &:last-of-type {
        border-bottom: none;
      }
    }
  }
}
div[aria-expanded='true'] {
  & > .collapse_arrow {
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}
.collapse_arrow {
  float: right;
  vertical-align: middle;
  font-size: $font-18;
}
.label_container {
  display: flex;
  align-items: center;
  padding: 5px 10px 5px 0px;
  border-bottom: 0.5px solid $gray74;
}
.flex_grow_1 {
  flex-grow: 1;
}
.desc_text,
.module-text {
  padding-bottom: 8px;
  padding-top: 8px;
}
.desc_text {
  font-size: $font-14;
  border-bottom: 0.5px solid $gray74;
}

hr {
  margin-top: 8px;
  margin-bottom: 0px;
}
.modal-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: $font-weight-medium;
  font-size: $font-20;
  color: $primary;
}
.mem-name {
  font-family: Roboto;
  font-style: normal;
  font-weight: $font-weight-normal;
  font-size: $font-12;
  color: $black;
}
.modal-body {
  height: 60vh;
  padding-top: 5px;
  overflow-y: auto;
}
#permissionsAccess {
  & > div {
    width: 75% !important;
    margin: 0px;
  }
}
.modal-content {
  &.first-modal-content {
    border-radius: 12px;
  }
}
.modal-header {
  padding: 15px 30px;
  .close {
    background: none;
    opacity: 0.5;
    height: 17px;
    @include fontItems($font-38, 28px, $font-weight-small);
    color: $deep-gray !important;
    width: 17px;
    border-radius: $radius20;
    outline: none;
    z-index: 1;
  }
  &.modal-bgcolor {
    background-color: $deep-white;
    border: $radius0;
    border-radius: 5px;
    padding-bottom: 0px;
  }
}
.modal-footer {
  &.modal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: 5px;
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
  }
}
.link-disabled {
  opacity: 0.4;
}
@media screen and (max-width: 767px) {
  .modal-header {
    padding: 15px;
  }
  .module-text {
    padding: 0;
  }
  .xs-mr-15 {
    margin-right: 15px;
  }
  .xs-ml-15 {
    margin-left: 15px;
  }
  #permissionsAccess > div {
    width: 95% !important;
  }
}
@media (max-width: 768px) and (max-width: 1024px) {
  .modal-body {
    height: 48vh;
  }
}
@media (width: 1024px) and (height: 768px) {
  .modal-body {
    height: 50vh;
  }
}
@media (device-width: 812px) and (device-height: 375px) {
  .modal-body {
    height: 52vh;
  }
}
</style>
